import {ReactNode} from "react";
import ToolBar, {ToolBarProps} from "./toolbar/ToolBar";
import classes from "./HorizontalListView.module.css";

type HorizontalListViewPropsBase = {
    /**
     * Children to be wrapped
     * @author Kacper Faber
     * @since 0.1.9
    */
    children?: ReactNode | ReactNode[];
};

type HorizontalListViewProps = HorizontalListViewPropsBase & ToolBarProps;

function HorizontalListView(props: HorizontalListViewProps) {
    return (
        <div style={{ width: '100%' }}>
            <ToolBar
                {...props}
            />

            <div className={classes.container}>
                { props.children }
            </div>
        </div>
    );
}

export default HorizontalListView;

// TODO: HorizontalListView.tsx
//  Add some docs